"use client"

import { generateResponsiveCSS } from "@/(admin)/modules/ui-builder/config/lib/helper"
import type { ComponentConfig } from "@measured/puck"
import { useMemo } from "react"
import { twMerge } from "tailwind-merge"
import { QuestionAndAnswerContent } from "./components/QuestionAndAnswerContent"
import type { QuestionAndAnswerProps } from "./types"

export const RenderConfig: ComponentConfig<QuestionAndAnswerProps> = {
  render: ({ className, styles, responsiveType, id: componentId, title, faqs }: QuestionAndAnswerProps & { id?: string }) => {
    const id = useMemo(
      () => componentId || `question-and-answer-${Math.random().toString(36).substr(2, 9)}`,
      [componentId],
    )
    const responsiveCSS = generateResponsiveCSS(id, styles || {}, responsiveType || "mobileFirst")

    return (
      <>
        {responsiveCSS}
        <QuestionAndAnswerContent id={id} title={title} faqs={faqs} className={twMerge(id, className)} />
      </>
    )
  },
}
